import React from "react";
import CodeSnippet from "../index-sections/CodeSnippet.js";

import {
  Button,
  Container,
  Row,
  Col,
} from "reactstrap";

import Navbar from "components/Navbars/IndexNavbar";
import Header from "components/Headers/IndexHeader";
import Footer from "components/Footers/DemoFooter.js";

function Express() {
  document.documentElement.classList.remove("nav-open");
  React.useEffect(() => {
    document.body.classList.add("profile-page");
    return function cleanup() {
      document.body.classList.remove("profile-page");
    };
  });
  return (
    <>
        {/* Navbar */}
        <Navbar />

        {/* Header */}
        <Header />
        
        {/* Inizio del contenuto della pagina */}
        <div className="main">
            <div className="section text-center">
                {/* Inizio del container */}
                <Container>
                    <Row>
                        <Col className="ml-auto mr-auto" md="8">
                            {/* Titolo */}
                            <h2 className="title">Express</h2>
                            {/* Descrizione */}
                            <h5 className="description">
                                Express.js (comunemento chiamato Express) è un framework Web utilizzato per il routing e per il middleware.
                            </h5>
                            <br />
                        </Col>
                    </Row>
                </Container>
                {/* Fine del container */}
            </div>


            {/* Inizio snippet del codice */}
            <CodeSnippet
                language="javascript"
                description="Con questo codice è possibile analizzare il funzionamento dei middleware per andare a suddividere una web app in più pagine"
                code={`//In questo caso non ho più bisogno di importare il modulo "http" in quanto uso già "express"
var express = require("express")

//Istanzio app
var app = new express ();

//Creo un middleware
app.get("/", (req, res) => {
    res.send("Benvenuto")
})

//Creo un 2° middleware per la 2° pagina del sito
app.get("/secondapagina", (req, res) => {
    res.send("Io sono la seconda pagina")
})

/*
Posso creare quanti middleware voglio...
Posso crearli con:
    - GET --> digito la pagina nell'URL (127.0.0.1:3001/secondapagina)
    - POST --> l'utente passa dei parametri al server usanto method="POST"
    - USE
*/

/*
Istanzio il mio server
app.listen è una callback con il numero della porta su cui il servizio è attivo (nel mio caso ho scelto la 3001)
*/
var server = app.listen(3001, () => {

    //Console.log che mi dice che il server è in esecuzione sulla porta 3001
    console.log("Server in esecuzione sulla porta 3001")
})`}
            />
            {/* Fine snippet del codice */}

            {/* Inizio button per codice completo */}
            <div className="section text-center">
                <Button className="btn-round mr-1" color="info" outline type="button" href="https://github.com/MattiaBracco05/SCUOLA/tree/494a02a630bb3d1ee07a766e7f6b7da945d9c41b/5L/TPSIT/Node%20JS/express" target="_blank">
                    Visualizza codice completo
                </Button>
            </div>
            {/* Fine button per codice completo */}

            <div className="section text-center">
                {/* Inizio del container */}
                <Container>
                    <Row>
                        <Col className="ml-auto mr-auto" md="8">
                            {/* Titolo */}
                            <h2 className="title">Express con send file</h2>
                            {/* Descrizione */}
                            <h5 className="description" style={{color: 'black'}}>
                                Esempio più arricchito con l'utilizzo del comando sendFile
                            </h5>
                            <br />
                        </Col>
                    </Row>
                </Container>
                {/* Fine del container */}
            </div>

            {/* INIZIO CODICE HTML - index.html */}
            {/* Inizio snippet del codice */}
            <CodeSnippet
                language="html"
                description="Come prima cosa creo una semplice pagia HTML (index.html)"
                code={`<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta http-equiv="X-UA-Compatible" content="IE=edge">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>5L Bracco Express</title>
</head>
<body>
    <h1>Pagina di prova</h1>
</body>
</html>`}
            />
            {/* Fine snippet del codice */}
            {/* FINE CODICE HTML - index.html */}

            {/* INIZIO CODICE JAVASCRIPT - inizio.js */}
            {/* Inizio snippet del codice */}
            <CodeSnippet
                language="javascript"
                description="Con questo secondo codice vado sempre ad utilizzare i middleware ma stavolta quando nell'URL è presente /secndaPgaina mi verra restituitò il contenuto della pagina 'index.html' creata precedentemente"
                code={`//In questo caso non ho più bisogno di importare il modulo "http" in quanto uso già "express"
var express = require("express")

//Istanzio app
var app = new express ();

//Creo un middleware
app.get("/", (req, res) => {
    res.send("Benvenuto")
})

//Creo un 2° middleware per la 2° pagina del sito
app.get("/secondapagina", (req, res) => {
    res.sendFile(__dirname + "/index.html")
})

/*
Posso creare qaunti middleware voglio...
Posso crearli con:
    - GET --> digito la pagina nell'URL (127.0.0.1:3001/secondapagina)
    - POST --> l'utente passa dei parametri al server usanto method="POST"
    - USE
*/

/*
Istanzio il mio server
app.listen è una callback con il numero della porta su cui il servizio è attivo (nel mio caso ho scelto la 3001)
*/
var server = app.listen(3001, () => {

    //Console.log che mi dice che il server è in esecuzione sulla porta 3001
    console.log("Server in esecuzione sulla porta 3001")
})`}
            />
            {/* Fine snippet del codice */}
            {/* FINE CODICE JAVASCRIPT - inizio.js */}

            {/* Inizio button per codice completo */}
            <div className="section text-center">
                <Button className="btn-round mr-1" color="info" outline type="button" href="https://github.com/MattiaBracco05/SCUOLA/tree/494a02a630bb3d1ee07a766e7f6b7da945d9c41b/5L/TPSIT/Node%20JS/express_con_sendfile" target="_blank">
                    Visualizza codice completo
                </Button>
            </div>
            {/* Fine button per codice completo */}

        </div>
        {/* Fine del contenuto della pagina */}
        
        {/* Footer */}
        <Footer />
    </>
  );
}

export default Express;
